export default __webpack_public_path__ + "static/media/avatar-assistant.e8ecbb0a.png";